import parseNumber from "@store/utilities/parseNumber";
import Color from "color";

const STATIC_PATH = "/userfiles/_static/store";

// -- Colors

const swatch = {
    white: "#ffffff",
    black: "#000000",
    grey: {
        lighter: "#F5F5F5",
        light: "#E8E8E8",
        lightish: "#AAAAAA",
        base: "#7D7F83",
        dark: "#474A4E",
        darker: "#2D2E31",
    },
};

export const COLORS = {
    white: swatch.white,
    black: swatch.black,
    primary: {
        light: "#E9131E",
        base: "#B5111A",
        dark: "#841A20",
    },
    secondary: {
        light: "#474A4E",
        base: "#2D2E31",
        dark: "#000000",
    },
    tertiary: {
        light: "#D8D8DA",
        base: "#828388",
        dark: "#58595B",
    },
    success: "#028526",
    successBackground: "#B6E8C4",
    error: "#DF1642",
    errorBackground: "#f8cbd5",
    warning: "#FFBB38",
    warningBackground: "#FFEBC6",
    info: "#3C84B2",
    background: {
        base: swatch.white,
        alt: swatch.grey.lighter,
        hover: swatch.grey.light,
    },
    border: {
        lighter: "#EDEEF0",
        base: swatch.grey.light,
        almostDark: swatch.grey.dark,
        dark: "#979797",
        darker: swatch.grey.darker,
    },
    disabled: {
        lighter: swatch.grey.lighter,
        light: swatch.grey.light,
        base: swatch.grey.base,
        dark: swatch.grey.dark,
        select: swatch.grey.lightish,
    },
    text: {
        thelightest: "#CECDCD",
        lighter: swatch.grey.base,
        light: "#828388",
        base: swatch.grey.darker,
        almostDark: "#58595B",
        dark: "#2D2E31",
    },
    link: {
        base: "#B5111A",
        hover: "#841A1F",
    },
    shadow: {
        light: "rgba(48, 49, 51, 0.05)",
        base: "rgba(48, 49, 51, 0.1)",
    },
    pagination: {
        base: swatch.grey.light,
        hover: Color(swatch.grey.light).darken(0.15).hex(),
        border: "#e2e3e4",
    },
    table: {
        selected: "#aaaaaa",
        hover: "#ebeaeb",
    },
    outline: "#3C84B2",
};

// -- Typography

const fallbackFont = "Arial, Helvetica, sans-serif";

export const TYPOGRAPHY = {
    fontFamily: {
        title: `'aktiv-grotesk', ${fallbackFont}`,
        base: `'aktiv-grotesk', ${fallbackFont}`,
    },
    weight: {
        base: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
        black: 800,
    },
    size: {
        veryTiny: "10px",
        tiny: "12px",
        smallest: "13px",
        smaller: "14px",
        small: "15px",
        base: "16px",
        large: "18px",
        larger: "20px",
    },
    lineHeight: {
        smaller: 1,
        small: 1.25,
        base: 1.5,
        large: 2,
    },
    spacing: {
        small: "0.5em",
        base: "1em",
        large: "1.5em",
        larger: "2em",
        largest: "3em",
    },
};

export const SPACING = {
    doublexxlarge: "6em",
    xxxlarge: "4em",
    xxlarge: "3em",
    xlarge: "2em",
    large: "1.5em",
    medium: "1.25em",
    standard: "1em",
    small: ".75em",
    xsmall: ".5em",
    xxsmall: ".25em",
};

// -- Common

const contentWidth = 1500;
const largeContentWidth = 1800;
const spacing = {
    side: ["20px", "30px", "45px", "45px", "60px"],
    content: ["25px", "30px", "45px", "45px", "60px"],
    narrowContent: ["25px", "30px", "40px", "40px", "50px"],
};

const largestSideSpacing = spacing.side.filter(x => x).pop() as any;
const siteWidth = contentWidth + (parseNumber(largestSideSpacing) ?? 0) * 2;

export const COMMON = {
    breakpoints: [0, 600, 900, 1200, siteWidth],
    width: {
        content: contentWidth,
        largeContent: largeContentWidth,
        site: siteWidth,
    },
    spacing,
    outline: {
        width: "2px",
        style: "solid",
    },
    defaultProductImagePath: `${STATIC_PATH}/product-not-available.svg`,
    defaultCategoryImagePath: `${STATIC_PATH}/category-not-available.svg`,
};
